$(function ()
{
	$(el("mainContainer")).on("click", "#btnAuthenticateNavigation", function(e)
	{
		e.preventDefault();
		var sId = $(this).data("id");

		authenticateNavigation(sId);
	});
});

function authenticateNavigation(sId)
{
	$("#btnAuthenticateNavigation").prop("disabled",true);

	var oCall = validatePasswordForNavigation(sId);
	oCall.success(function(oData)
	{
		if(oData.errorType == "" && oData.redirect !== "")
		{
			window.location.href = oData.redirect;
		}
		else
		{
			$("#btnAuthenticateNavigation").prop("disabled",false);
			inlineAlert("error", oData.errorMessage, oData.errorUnhandled, $("#btnAuthenticateNavigation"),false,5000);
		}
	});
}

function validatePasswordForNavigation(sId)
{
	uAjax = "/index.cfm/product/ajax/validatepasswordfornavigation";
	var sParams = "&id=" + sId + "&password=" + $("#authenticateInputPassword").val();

	return oCall = callAjax("validatepasswordfornavigation", sParams, "post");
}